import React, { useEffect, useRef, useState, useCallback } from "react";
import CategoryCard from "./CategoryCard";
import { MdArrowBack } from "react-icons/md";
import {
    FaChartLine,
    FaGlobe,
    FaCoins,
    FaUniversity,
    FaBalanceScale,
    FaHandshake,
    FaMoneyBillWave,
    FaExchangeAlt,
    FaDatabase,
    FaClock,
    FaNewspaper,
    FaCogs,
    FaRegLightbulb,
    FaFileAlt,
    FaBuilding,
    FaIndustry,
    FaOilCan,
    FaBolt,
    FaSeedling,
    FaLeaf,
    FaFish,
    FaGem,
    FaTools,
    FaSnowflake,
    FaClipboardList,
    FaBookOpen,
    FaBoxOpen,
    FaTruck,
    FaMapMarkerAlt,
    FaStar,
    FaStore,
    FaInfoCircle,
    FaRecycle,
    FaShieldAlt,
    FaGavel,
    FaChartPie,
    FaFilter,
    FaProjectDiagram,
    FaRobot,
    FaLock,
    FaSyncAlt,
    FaBroadcastTower,
    FaMobileAlt,
    FaComments,
    FaFileExcel,
    FaTachometerAlt,
    FaBell,
    FaLink,
    FaLandmark,
    FaBriefcase,
    FaRegSmile,
    FaHashtag,
    FaEye,
    FaReceipt,
    FaSatelliteDish,
    FaPhoneAlt,
    FaNotesMedical,
    FaCreditCard,
    FaUsers,
    FaLayerGroup,
    FaUserSecret,
    FaVideo,
    FaBan,
    FaPlaneDeparture,
    FaCamera,
    FaStoreAlt,
    FaKeyboard,
    FaSearch,
    FaChartArea,
    FaCashRegister,
    FaFileInvoiceDollar,
    FaEnvelopeOpenText,
    FaHelicopter,
    FaServer,
    FaMapMarkedAlt,
    FaBullseye,
    FaFileSignature,
    FaStarHalfAlt,
    FaShareAlt,
    FaSlidersH,
    FaDownload,
    FaUserTie,
    FaLanguage,
    FaFont,
    FaHandHoldingUsd, FaCity, FaFlag, FaCloud, FaExclamationTriangle, FaScroll, FaClipboardCheck,
    FaBook,
    FaRegChartBar,
    FaGlobeAmericas,
    FaGlobeEurope,
    FaGlobeAsia,
    FaHistory,
    FaThumbtack,
    FaCalendarAlt,
    FaRegCalendar,
    FaCalendarWeek,
    FaCalendarDay,
    FaCalculator,
    FaBullhorn,
    FaMicroscope,
    FaStamp,
    FaRegFileAlt,
    FaLightbulb,
    FaFolderOpen
} from "react-icons/fa";
import axios from "axios";

const categoryIconMap = {
    "Fixed Income Prices": FaChartLine,
    "Bond Geographical Markets": FaGlobe,
    "Bonds": FaCoins,
    "Bond Derivatives": FaBalanceScale,
    "Treasury Data": FaUniversity,
    "Broker Prices": FaHandshake,
    "Third Party Services": FaCogs,
    "Money Market Rates": FaMoneyBillWave,
    "Foreign Exchange Rates": FaExchangeAlt,
    "Fixed Income Descriptive Data": FaDatabase,
    "Fixed Income Data Items Historic": FaClock,
    "News": FaNewspaper,
    "Securitised Products": FaFileAlt,
    "Credit Products": FaRegLightbulb,
    "Regulatory": FaClipboardList,
    "Fixed Income Indices": FaBookOpen,
    "Equity Prices": FaChartLine,
    "Equity Geographical Markets": FaGlobe,
    "Equity Indices": FaBookOpen,
    "Equity Derivatives": FaBalanceScale,
    "Equity Price Fields": FaDatabase,
    "Equity Coverage - Other": FaFileAlt,
    "Equity Fundamental Analysis": FaRegLightbulb,
    "Equity Analysis - Other": FaRegLightbulb,
    "NEWS": FaNewspaper,
    "Analytical Commentaries": FaBookOpen,
    "Regulatory/Reporting Standards": FaClipboardList,
    "Commodity Prices": FaChartLine,
    "Commodities Geographical Markets": FaGlobe,
    "Commodities": FaCoins,
    "Oil": FaOilCan,
    "Power": FaBolt,
    "Oilseeds/Grain": FaSeedling,
    "Softs / Plantation Crops": FaLeaf,
    "Livestock": FaFish,
    "Precious Metals": FaGem,
    "Base Metals": FaTools,
    "Plastics": FaIndustry,
    "Weather": FaSnowflake,
    "Commodity Derivatives": FaBalanceScale,
    "Commodity Descriptive Data": FaDatabase,
    "Commodity Indices": FaBookOpen,
    "Industrial Minerals": FaIndustry,
    "Forestry": FaLeaf,
    "Product Type": FaBoxOpen,
    "Delivery": FaTruck,
    "Data Type": FaDatabase,
    "Market": FaGlobe,
    "Region": FaMapMarkerAlt,
    "Tier": FaStar,
    "Vendor Type": FaStore,
    "Alternative Data Provider": FaDatabase,
    "Broker Research Provider": FaChartLine,
    "Dealer/Broker": FaHandshake,
    "Dealer/Money Maker": FaCoins,
    "Dealer/Market Maker": FaCoins,
    "Exchange/Trading Venue": FaExchangeAlt,
    "Index Provider": FaStar,
    "Information Provider": FaInfoCircle,
    "News Agency": FaNewspaper,
    "Technology Provider": FaCogs,
    "Environmental Commodities": FaRecycle,
    "Energy Transition": FaBolt,
    "Climate Change": FaLeaf,
    "ESG Impact Metrics/Scores": FaChartPie,
    "ESG Indices": FaBookOpen,
    "ESG News": FaNewspaper,
    "ESG Rankings": FaStar,
    "ESG Ratings": FaLeaf,
    "ESG Research/Reports/Analysis": FaBookOpen,
    "ESG Risk Scores": FaShieldAlt,
    "ESG Sentiment": FaChartPie,
    "ESG Signals/Events": FaBell,
    "Green bonds": FaLeaf,
    "Emissions": FaRecycle,
    "Scope 1": FaRecycle,
    "Scope 2": FaRecycle,
    "Scope 3": FaRecycle,
    "Sustainable Finance": FaMoneyBillWave,
    "EU Taxonomy": FaClipboardList,
    "SFDR": FaClipboardList,
    "TCFD": FaClipboardList,
    "MAR": FaGavel,
    "AI": FaRobot,
    "Big Data": FaDatabase,
    "Data Storage (Databases)": FaDatabase,
    "Data analysis infrastructure": FaProjectDiagram,
    "Data management and security": FaLock,
    "Data transformation": FaCogs,
    "Hadoop and Spark framework": FaCogs,
    "Machine learning tools": FaRobot,
    "Technology consulting firms": FaCogs,
    "Dashboards": FaTachometerAlt,
    "Streaming Data": FaBroadcastTower,
    "Refresh Data": FaSyncAlt,
    "Customisation": FaCogs,
    "General Search Facility": FaFilter,
    "News Search Facility": FaFilter,
    "Back testing": FaChartLine,
    "Screening": FaFilter,
    "Scenario Analysis (tools)": FaProjectDiagram,
    "Straight-Through-Processing (STP)": FaCogs,
    "Instant Messaging": FaComments,
    "Portable/Mobile Web Access": FaMobileAlt,
    "Web Links": FaLink,
    "Web links": FaLink,
    "Download DDE Functions Excel": FaFileExcel,
    "Download Functions Excel, PDF, Word": FaFileExcel,
    "Excel,  PDF, Word export": FaFileExcel,
    "ESG Index provider": FaChartPie,
    "ESG Ratings provider": FaStar,
    "ESG-specialist provider": FaSeedling,
    "Governmental agencies / NGOs": FaLandmark,
    "Market data vendor offering ESG": FaDatabase,
    "Corporate/Market": FaBriefcase,
    "Sentiment": FaRegSmile,
    "Web/App/Mobile/Social Media": FaHashtag,
    "News & Views": FaEye,

    "Transactions": FaReceipt,
    "Government": FaLandmark,

    "Sensors - Satellite": FaSatelliteDish,
    "Sensors - Geolocation": FaMapMarkerAlt,

    "Environmental": FaLeaf,
    "Blogs, Pictures & Video Analytics": FaVideo,
    "Call Detail Records": FaPhoneAlt,
    "Clinical Records": FaNotesMedical,

    "Credit Card": FaCreditCard,
    "Crowd Sourcing": FaUsers,
    "Data Aggregators": FaLayerGroup,
    "Data Broker": FaUserSecret,
    "Denied Party Screening Trade Data": FaBan,
    "Aircraft/Drone": FaHelicopter,
    "Duty Collections": FaFileInvoiceDollar,
    "Email & Purchase Receipts": FaEnvelopeOpenText,
    "Flight Schedules": FaPlaneDeparture,
    "Geolocation": FaMapMarkedAlt,
    "Hosting": FaServer,
    "Images": FaCamera,
    "In-Store Sensors": FaStoreAlt,
    "Management Statements": FaBullseye,
    "Manual Entry": FaKeyboard,
    "Market Data Service Providers": FaDatabase,
    "Online Search": FaSearch,
    "Orderbook & Flow Data": FaChartArea,
    "Point of Sale": FaCashRegister,
    "Reports & Filings": FaFileSignature,
    "Retail (store-level) Datafeeds": FaStoreAlt,
    "Satellite": FaSatelliteDish,
    "Scoring": FaStarHalfAlt,
    "Sell-Side": FaChartLine,
    "Social Media": FaShareAlt,
    "Surveys": FaSlidersH,
    "Alerts": FaBell,
    "Charting": FaChartLine,
    "Contribution to Third Parties": FaShareAlt,
    "Data Analysis": FaChartPie,
    "Data Manipulation": FaCogs,

    "Data Coverage": FaLayerGroup,
    "Data Frequency": FaClock,
    "Alt Data Markets": FaGlobe,

    "Camera/Video": FaCamera,
    "Radar": FaSatelliteDish,
    "NLP": FaLanguage,

    "Text Parsing": FaFont,
    "Web Scraping": FaSearch,
    "Blockchain": FaLink,
    "Granular Company Metrics/Data/KPIs": FaTachometerAlt,
    "Company level": FaBuilding,
    "City level": FaCity,
    "Country level": FaFlag,
    "Instrument level / Portfolio level / Fund level": FaLayerGroup,
    "Sector/market level": FaGlobe,
    "Sub-national level": FaMapMarkedAlt,

    "Climate": FaCloud,
    "Green/Brown Revenue": FaMoneyBillWave,
    "Governance": FaBalanceScale,
    "Controversies": FaExclamationTriangle,
    "Norms": FaScroll,
    "Weapons": FaBullseye,
    "Sanctions": FaBan,

    "Regulatory Reporting": FaClipboardCheck,
    "E - Environmental and Energy Related Issues": FaBolt,
    "S - Social / Societal Issues and Concerns": FaUsers,

    "G - Corporate Governance": FaBalanceScale,
    "Sustainability Accounting Standards Board (SASB)": FaBook,

    "Benchmarks - Alignment with EU Climate Transition benchmark standards": FaRegChartBar,
    "Benchmarks - Alignment with EU Paris benchmark standards": FaRegChartBar,

    "Sustainable Finance Disclosure Regulation (SFDR)": FaClipboardList,
    "Task Force on Climate-related Financial Disclosures (TCFD)": FaClipboardList,

    "UN Global Compact (UNGC)": FaHandshake,
    "UN Principles for Responsible Investment (PRI)": FaHandshake,
    "UN Sustainable Development Goals (SDGs)": FaLeaf,

    "Global Markets": FaGlobe,
    "APAC Markets": FaGlobeAsia,
    "LATAM Markets": FaMapMarkedAlt,
    "MEA Markets": FaMapMarkedAlt,
    "North American Markets": FaGlobeAmericas,
    "European Markets": FaGlobeEurope,
    "Emerging Markets": FaGlobe,
    "Forecast/Predictive": FaChartLine,

    "Current": FaClock,
    "Historical": FaHistory,
    "Static": FaThumbtack,

    "Annual": FaCalendarAlt,
    "Quarterly": FaRegCalendar,
    "Monthly": FaRegCalendar,
    "Weekly": FaCalendarWeek,
    "Daily": FaCalendarDay,
    "Real-time": FaBroadcastTower,

    "ESG Vendor Estimates": FaCalculator,
    "ESG Disclosures 'As reported'": FaFileAlt,
    "Media": FaBullhorn,
    "Govt Agencies/NGOs": FaLandmark,
    "Academic": FaUniversity,
// ---- Standards / frameworks / institutions ----
    "Scientific": FaMicroscope,
    "Global Reporting Initiative (GRI/WEF)": FaBook,
    "UN Guiding Principles on Business & Human Rights (UN GPs)": FaBalanceScale,
    "OECD Guidelines for Multinational Enterprises": FaGlobe,

    "ILO Labour Conventions": FaUsers,
    "ISSB IFRS Disclosure Standards": FaStamp,
    "CDSB Framework": FaRegFileAlt,
    "Social Impact / Responsibility": FaUsers,

// ---- Data sources / provenance ----
    "Third party data providers": FaUserTie,
    "Geolocation sources": FaMapMarkedAlt,
    "Company interviews": FaComments,
    "Proprietary research/analysis": FaLightbulb,
    "Client data": FaFolderOpen,
    "Open Sources": FaGlobe,


};

export default function TabbedCategoryCardGroup({
                                                    type,
                                                    moduleId,
                                                    mode,
                                                    categoryTabs,
                                                    selectedItemsMap,
                                                    hasSubmittedSearch = false,
                                                    onHasSubmittedSearchChange,
                                                    onItemSelectionChange,
                                                    onSearch = () => {},
                                                    setViewMode = () => {},
                                                }) {
    const numericModuleId = Number(moduleId);
    const shouldAutoSearchLeafCards =
        type === "feature" &&
        mode === "altdata" &&
        (numericModuleId === 9 || numericModuleId === 10);

    const [activeTab, setActiveTab] = useState(null);
    const [childItems, setChildItems] = useState([]);
    const [selected, setSelected] = useState(
        Array.isArray(selectedItemsMap) ? selectedItemsMap : []
    );

    const [selectedLeafHeaders, setSelectedLeafHeaders] = useState([]);

    const [hasChildrenMap, setHasChildrenMap] = useState({});

    const [prefetchedMap, setPrefetchedMap] = useState({});

    const [checkingHeaderId, setCheckingHeaderId] = useState(null);


    useEffect(() => {
        setSelected(Array.isArray(selectedItemsMap) ? selectedItemsMap : []);
    }, [selectedItemsMap]);

    useEffect(() => {
        if (type === "feature" && Array.isArray(selectedItemsMap)) {
            setSelectedLeafHeaders(selectedItemsMap);
        }
    }, [type, selectedItemsMap]);

    useEffect(() => {
        setSelected([]);
        setActiveTab(null);
    }, [categoryTabs, type, moduleId, mode]);

    useEffect(() => {
        setChildItems([]);
        setSelected(Array.isArray(selectedItemsMap) ? selectedItemsMap : []);
        if (
            type === "category" &&
            categoryTabs.length === 1 &&
            categoryTabs[0].categoryId
        ) {
            const fetchChildren = async () => {
                try {
                    const headers = {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                        "Content-Type": "application/json",
                    };
                    const qs = new URLSearchParams();
                    if (mode) qs.set("mode", mode);
                    if (moduleId) qs.set("moduleId", String(moduleId));
                    const url =
                        `${process.env.REACT_APP_API_URL}/category-items/by-category/${categoryTabs[0].categoryId}` +
                        (qs.toString() ? `?${qs.toString()}` : "");
                    const response = await axios.get(url, { headers });
                    setChildItems(response.data);
                } catch (err) {
                    console.error("Failed to fetch category items", err);
                }
            };
            fetchChildren();
        }
    }, [categoryTabs, type, mode, moduleId]);

    const commitLeafSelection = useCallback((ids) => {
        setViewMode("Discovery Builder");
        if (!hasSubmittedSearch) {
            onHasSubmittedSearchChange?.(true);
        }
        onItemSelectionChange?.(ids);
        onSearch?.(ids);
    }, [hasSubmittedSearch, onHasSubmittedSearchChange, onItemSelectionChange, onSearch, setViewMode]);

    const toggleLeafHeader = useCallback((id, options = {}) => {
        const shouldCommit = options.commit === true;
        const prev = selectedLeafHeaders;
        const next = prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id];
        setSelectedLeafHeaders(next);
        if (shouldCommit) {
            commitLeafSelection(next);
        }
    }, [commitLeafSelection, selectedLeafHeaders]);

    const ensureFeatureHeaderMeta = useCallback(
        async (headerId) => {
            if (type !== "feature") return { hasChildren: true, list: null };
            if (!moduleId) return { hasChildren: true, list: null };

            // already known
            if (hasChildrenMap[headerId] === false) return { hasChildren: false, list: null };
            if (hasChildrenMap[headerId] === true) return { hasChildren: true, list: prefetchedMap[headerId] || null };

            setCheckingHeaderId(headerId);

            try {
                const headers = {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    "Content-Type": "application/json",
                };

                const url = `${process.env.REACT_APP_API_URL}/features/by-module/${moduleId}/${headerId}`;
                const res = await axios.get(url, { headers });

                const list = Array.isArray(res.data) ? res.data : [];
                const hasChildren = list.length > 0;

                setHasChildrenMap((m) => ({ ...m, [headerId]: hasChildren }));
                if (hasChildren) {
                    setPrefetchedMap((p) => ({ ...p, [headerId]: list }));
                }

                return { hasChildren, list: hasChildren ? list : null };
            } catch (e) {
                console.error("Failed to check feature header children", e);
                // If unsure, fall back to opening
                setHasChildrenMap((m) => ({ ...m, [headerId]: true }));
                return { hasChildren: true, list: null };
            } finally {
                setCheckingHeaderId(null);
            }
        },
        [type, moduleId, hasChildrenMap, prefetchedMap]
    );

    const runLeafSearch = useCallback(() => {
        commitLeafSelection(selectedLeafHeaders);
    }, [commitLeafSelection, selectedLeafHeaders]);

    const clearLeaf = useCallback(() => {
        setSelectedLeafHeaders([]);
        if (!hasSubmittedSearch) {
            onHasSubmittedSearchChange?.(true);
        }
        onItemSelectionChange?.([]);
    }, [hasSubmittedSearch, onHasSubmittedSearchChange, onItemSelectionChange]);

    if (
        type === "category" &&
        categoryTabs.length === 1 &&
        childItems.length > 0 &&
        !activeTab
    ) {
        const gridColsClass =
            childItems.length === 1
                ? "grid-cols-1"
                : childItems.length < 10
                    ? "grid-cols-3"
                    : "grid-cols-2 sm:grid-cols-3 md:grid-cols-4";
        const justifyClass = childItems.length === 1 ? "justify-center" : "";

        const toggleCard = (id) => {
            const next = selected.includes(id)
                ? selected.filter((v) => v !== id)
                : [...selected, id];
            setSelected(next);
            if (!hasSubmittedSearch) {
                onHasSubmittedSearchChange?.(true);
            }
            onItemSelectionChange?.(next);
        };

        return (
            <div className="w-full flex flex-col items-center mt-2">
                <div className={`grid ${justifyClass} gap-4 mt-2 mb-2 ${gridColsClass}`}>
                    {childItems.map((item) => {
                        const IconComponent = categoryIconMap[item.item] || FaFileAlt;
                        const checked = selected.includes(item.id);

                        return (
                            <button
                                key={item.id}
                                type="button"
                                onClick={() => toggleCard(item.id)}
                                aria-pressed={checked}
                                className={`relative w-40 h-28 flex flex-col items-center justify-center
                          p-3 rounded-2xl font-semibold text-[#25408f] text-sm transition
                          shadow border-2 focus:outline-none focus:ring-2
                          ${
                                    checked
                                        ? "bg-[#fff7f2] border-[var(--rusty-orange)] ring-[var(--rusty-orange)]"
                                        : "bg-[#f9f9f9] border-[#d1d5db] hover:bg-[#f0f0f0] hover:-translate-y-1"
                                }`}
                            >
                                <IconComponent className="text-xl mb-1" />
                                <span className="text-xs text-center">{item.item}</span>

                                {checked && (
                                    <span className="absolute top-2 right-2 inline-flex items-center justify-center
                                  w-5 h-5 rounded-full bg-[var(--rusty-orange)] text-white text-[10px]">
                  ✓
                </span>
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>
        );
    }

    // ---------- Drilldown ----------
    if (activeTab && categoryTabs.length > 0) {
        return (
            <div className="max-h-[550px] w-full max-w-4xl mx-auto mt-4">
                <button
                    onClick={() => setActiveTab(null)}
                    className="flex items-center text-black text-sm mb-4"
                >
                    <MdArrowBack className="mr-1" /> Back
                </button>

                <div className="p-6 bg-white rounded-xl border border-gray-200 shadow-md">
                    <CategoryCard
                        type={type}
                        moduleId={moduleId}
                        mode={mode}
                        sourceId={activeTab}
                        effectiveSelectedItems={type === "feature" ? selectedLeafHeaders : selected}
                        selectedItems={[]} // keep your current “select inside and Search” behavior
                        prefetchedItems={type === "feature" ? prefetchedMap[activeTab] : null} // ✅ NEW
                        onSearch={(idsFromCard) => {
                            // ✅ preserve any leaf-header ticks when searching from inside a drilldown
                            const merged = Array.from(new Set([...(selectedLeafHeaders || []), ...(idsFromCard || [])]));
                            setSelectedLeafHeaders(merged);
                            setViewMode("Discovery Builder");
                            onItemSelectionChange?.(merged);
                            onSearch?.(merged);
                        }}
                        setViewMode={setViewMode}
                    />
                </div>
            </div>
        );
    }

    if (!categoryTabs.length) return null;

    const gridColsClass =
        categoryTabs.length === 1
            ? "grid-cols-1"
            : categoryTabs.length < 10
                ? "grid-cols-3"
                : "grid-cols-2 sm:grid-cols-3 md:grid-cols-4";
    const justifyClass = categoryTabs.length === 1 ? "justify-center" : "";

    return (
        <div className="w-full flex flex-col items-center mt-4">
            <div className={`grid ${justifyClass} gap-4 my-4 ${gridColsClass}`}>
                {categoryTabs.map(({ label, categoryId }) => {
                    const IconComponent = categoryIconMap[label] || FaFileAlt;

                    const knownHasChildren = hasChildrenMap[categoryId];
                    const isLeaf = type === "feature" && knownHasChildren === false;
                    const checked = type === "feature" && isLeaf && selectedLeafHeaders.includes(categoryId);
                    const checking = checkingHeaderId === categoryId;

                    return (
                        <button
                            key={categoryId}
                            type="button"
                            onClick={async () => {
                                if (type !== "feature") {
                                    setActiveTab(categoryId);
                                    return;
                                }

                                if (knownHasChildren === false) {
                                    toggleLeafHeader(categoryId, { commit: shouldAutoSearchLeafCards });
                                    return;
                                }

                                if (knownHasChildren === true) {
                                    setActiveTab(categoryId);
                                    return;
                                }

                                const meta = await ensureFeatureHeaderMeta(categoryId);
                                if (meta.hasChildren) setActiveTab(categoryId);
                                else toggleLeafHeader(categoryId, { commit: shouldAutoSearchLeafCards });
                            }}
                            aria-pressed={checked}
                            className={`relative w-40 h-28 flex flex-col items-center justify-center
                p-3 rounded-2xl font-semibold text-[#25408f] text-sm transition
                shadow border-2 focus:outline-none focus:ring-2
                ${
                                checked
                                    ? "bg-[#fff7f2] border-[var(--rusty-orange)] ring-[var(--rusty-orange)]"
                                    : "bg-[#f9f9f9] border-[#d1d5db] hover:bg-[#f0f0f0] hover:-translate-y-1"
                            }`}
                        >
                            <IconComponent className="text-xl mb-1" />
                            <span className="text-xs text-center">{label}</span>

                            {checking && (
                                <span className="absolute top-2 right-2 text-[10px] text-gray-500">
                  …
                </span>
                            )}

                            {checked && (
                                <span
                                    className="absolute top-2 right-2 inline-flex items-center justify-center
                  w-5 h-5 rounded-full bg-[var(--rusty-orange)] text-white text-[10px]"
                                >
                  ✓
                </span>
                            )}
                        </button>
                    );
                })}
            </div>

            {type === "feature" && !shouldAutoSearchLeafCards && selectedLeafHeaders.length > 0 && (
                <div className="flex items-center gap-2">
                    <button
                        type="button"
                        onClick={runLeafSearch}
                        className="px-6 py-2.5 bg-[#25408f] text-white rounded-2xl font-semibold shadow-md
              hover:bg-[#1f367a] active:bg-[#1e3372] active:scale-95 transition-all duration-200
              focus:outline-none focus:ring-2 focus:ring-[#465da0] focus:ring-offset-2"
                    >
                        Search
                    </button>

                    <button
                        type="button"
                        onClick={clearLeaf}
                        className="px-4 py-2.5 rounded-2xl font-semibold border border-gray-300 bg-white
              hover:bg-gray-50 active:scale-95 transition"
                    >
                        Clear
                    </button>
                </div>
            )}
        </div>
    );
}
